<div class="bilan-catalog-page">
  <app-prevention-group-header activeTab="offers"></app-prevention-group-header>
  <div class="breadcrumb-bar">
    <button class="breadcrumb-back" (click)="goBack()">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
      {{ 'preventionOffres.bilanCatalog.back' | translate }}
    </button>
    <span class="breadcrumb-sep">·</span>
    <a class="breadcrumb-link" routerLink="/pilotage-prevention">{{ 'preventionOffres.bilanCatalog.breadcrumb.prevention' | translate }}</a>
    <span class="breadcrumb-sep">·</span>
    <a class="breadcrumb-link" routerLink="/prevention-offres">{{ 'preventionOffres.bilanCatalog.breadcrumb.offers' | translate }}</a>
    <span class="breadcrumb-sep">·</span>
    <span class="breadcrumb-current">{{ 'preventionOffres.bilanCatalog.breadcrumb.current' | translate }}</span>
  </div>

  <div class="card" style="margin-bottom:16px">
    <div class="ct" style="margin-bottom:4px">{{ 'preventionOffres.bilanCatalog.title' | translate }}</div>
    <div class="cs" style="margin-bottom:14px">{{ 'preventionOffres.bilanCatalog.subtitle' | translate }}</div>
    <span class="bc-search">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
      <input
        class="bc-search-input"
        type="text"
        [attr.aria-label]="'preventionOffres.bilanCatalog.searchAriaLabel' | translate"
        [placeholder]="'preventionOffres.bilanCatalog.searchPlaceholder' | translate"
        [value]="search()"
        (input)="onSearchChanged($any($event.target).value)">
    </span>
  </div>

  @if (loadError()) {
    <div class="card"><div class="cs" style="text-align:center;padding:40px 0">{{ 'preventionOffres.bilanCatalog.error' | translate }}</div></div>
  } @else if (loading()) {
    <div class="card"><div class="cs" style="text-align:center;padding:40px 0">{{ 'preventionOffres.bilanCatalog.loading' | translate }}</div></div>
  } @else if (isGloballyEmpty()) {
    <div class="card"><div class="cs" style="text-align:center;padding:40px 0">{{ 'preventionOffres.bilanCatalog.emptyGlobal' | translate }}</div></div>
  } @else if (hasSearchNoResults()) {
    <div class="card"><div class="cs" style="text-align:center;padding:40px 0">{{ 'preventionOffres.bilanCatalog.emptySearch' | translate }}</div></div>
  } @else {
    <div class="bc-family-grid">
      @for (group of filteredGroups(); track group.family.code) {
        <div class="card">
          <div class="ct" style="margin-bottom:14px">{{ group.family.label }}</div>
          <div style="display:flex;flex-direction:column;gap:16px">
            @for (bilan of group.bilans; track bilan.code) {
              <div>
                <div style="font-size:13px;font-weight:600;color:var(--ink)">{{ bilan.name }}</div>
                @if (bilan.description) {
                  <div class="cs" style="margin-top:2px">{{ bilan.description }}</div>
                }
                @if (bilan.items.length > 0) {
                  <ul class="bilan-items-list">
                    @for (item of bilan.items; track item.position) {
                      <li>{{ item.label }}</li>
                    }
                  </ul>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
